import { Tutorial } from "@/types/tutorial";

interface TutorialStatusFilter {
  completedStatus?: "selected" | "excluded";
  notInterestedStatus?: "selected" | "excluded";
}

/**
 * Filters tutorials based on their completion and interest status
 * @param tutorials List of tutorials to filter
 * @param statusFilter Filter configuration for completed and not interested status
 * @param completedIds List of completed tutorial IDs
 * @param uninterestedIds List of uninterested tutorial IDs
 * @returns Filtered list of tutorials
 */
export function filterTutorialsByCompletionStatus(
  tutorials: Tutorial[],
  statusFilter: TutorialStatusFilter,
  completedIds: string[] = [],
  uninterestedIds: string[] = []
): Tutorial[] {
  const filteredtutorials = tutorials.filter((tutorial) => {
    const isCompleted = completedIds?.includes(tutorial.documentId);
    const isUninterested = uninterestedIds?.includes(tutorial.documentId);

    // By default, never show completed or not interested tutorials
    // Only show them when specifically selected

    // Special case: If the completed button is selected, show ONLY completed tutorials
    if (statusFilter.completedStatus === "selected") {
      return isCompleted;
    }

    // Special case: If the not interested button is selected, show ONLY not interested tutorials
    if (statusFilter.notInterestedStatus === "selected") {
      return isUninterested;
    }

    // Default behavior: Never show completed or not interested tutorials
    if (isCompleted || isUninterested) {
      return false;
    }

    return true;
  });

  return filteredtutorials;
}
